namespace advisorop.components.identity {

    interface IAccessDeniedFormController {        
        $router;
    }

    class AccessDeniedFormController implements IAccessDeniedFormController {
        
        $router;
        
        constructor() {            
        }
        
        $onInit(): void {
        }
    }



    class AccessDeniedForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                //textBinding: '@',
                $router: '<',
                //functionBinding: '&'
            };
            this.controller = AccessDeniedFormController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/access-denied-form.html';
        }

    }
    angular.module(Constants.APP).component("accessDeniedForm", new AccessDeniedForm());
}